module.exports = __webpack_public_path__ + "img/about-me.920a0d08.svg";